import { createAsyncThunk } from "@reduxjs/toolkit";

import { type TeamMemberRoleEnum } from "@fitness-app/data-models/entities/TeamMember";

import { type AsyncThunkCreator } from "../../../index";
import { buildTeamMemberPermissionConfiguration, type TeamMemberPermissionConfiguration } from "../permissions";
import { TEAM_REDUCER_NAME } from "../types";

interface Payload {
  memberId: string;
  role: TeamMemberRoleEnum;
}

export const fetchTeamMemberPermissionConfiguration = createAsyncThunk<
  TeamMemberPermissionConfiguration,
  Payload,
  AsyncThunkCreator<string>
>(
  `${TEAM_REDUCER_NAME}/fetchTeamMemberPermissionConfiguration`,
  async ({ memberId, role }, { rejectWithValue, extra: { db } }) => {
    const [catalogResult, baselineResult, grantResult] = await Promise.all([
      db.from("permission").select("key, description, overridable, grantableScopes").order("key"),
      db.from("role_permission").select("key, scope").eq("role", role),
      db.from("team_member_permission").select("key, scope").eq("memberId", memberId),
    ]);

    const error = catalogResult.error ?? baselineResult.error ?? grantResult.error;

    if (error) {
      return rejectWithValue(error.message);
    }

    return buildTeamMemberPermissionConfiguration({
      catalog: catalogResult.data ?? [],
      baselines: baselineResult.data ?? [],
      grants: grantResult.data ?? [],
    });
  },
);
